import { DateTime, DurationUnit, ZoneOptions } from 'luxon';

import { Injectable } from '@angular/core';

const defaultTimeZone = 'America/New_York';

@Injectable({
  providedIn: 'root'
})
export class TimeService {
  getCurrentTime(zone = defaultTimeZone): DateTime {
    return DateTime.now().setZone(zone);
  }

  getCurrentTimeFromJSDate(date: Date, zone = defaultTimeZone): DateTime {
    return DateTime.fromJSDate(date).setZone(zone);
  }

  parseDateFromMDY(dateString: string, zone = defaultTimeZone): DateTime {
    return DateTime.fromFormat(dateString, 'MM/dd/yyyy', { zone });
  }

  parseDateFromISO(dateString: string, options: ZoneOptions, zone = defaultTimeZone): DateTime {
    return DateTime.fromISO(dateString, { setZone: true }).setZone(zone, { ...options });
  }

  parseDateFromFormat(dateString: string, format: string, zone = defaultTimeZone): DateTime {
    return DateTime.fromFormat(dateString, format, { zone });
  }

  getDistanceBetweenDates(date1: DateTime, date2: DateTime, durationUnit = 'milliseconds' as DurationUnit): number {
    return date1.diff(date2).as(durationUnit);
  }
}